import app from 'flarum/forum/app';
export default function loadTools() {
  // Каталог загружается через единый серверный контракт без прямых запросов к моделям из интерфейса.
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/tools`
  });
}
flarum.reg.add('devconnect-tools', 'forum/service/toolApi', loadTools);